import React from 'react'
import HeaderSection from '../../../../components/common/Header/HeaderSection'
import AddForm from './ViewAll'
import { Box } from '@chakra-ui/react';

const View = () => {
    return (
        <div>
            <HeaderSection
                title="Assets Voucher"
                breadcrumb={["Dashboard", "Voucher", "Asset List"]}
            />
            <Box p={6}>

                <AddForm />
            </Box>
        </div>
    )
}

export default View